import { render, staticRenderFns } from "./TwUserProfileNotificationDialog.vue?vue&type=template&id=7179d586&scoped=true&"
import script from "./TwUserProfileNotificationDialog.vue?vue&type=script&lang=js&"
export * from "./TwUserProfileNotificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./TwUserProfileNotificationDialog.vue?vue&type=style&index=0&id=7179d586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7179d586",
  null
  
)

export default component.exports